import { makeStyles } from 'tss-react/mui'

import { Theme } from '@mui/material'

import { IMAGES_PATH } from 'themes'

const error403 = IMAGES_PATH('/errors/403.png')
const error404 = IMAGES_PATH('/errors/404.png')
const error503 = IMAGES_PATH('/errors/503.png')

const cardImage = type => {
    if (type === 403) {
        return error403
    }
    if (type === 404) {
        return error404
    }
    if (type === 408) {
        return error503
    }
    if (type === 500) {
        return error503
    }
    if (type === 502) {
        return error503
    }
    if (type === 503) {
        return error503
    }
}

export const useStyles = makeStyles<{ errorCode: number }>()((theme: Theme, { errorCode }) => ({
    errorContainer: {
        display: 'flex',
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        height: `calc(100vh - ${theme.variables.navHeight})`,

        '& .errorWrap': {
            backgroundColor: '#ffffff',
            borderRadius: theme.variables.paper.borderRadius,
            boxShadow: '0 0 8px 0 rgba(154, 154, 154, 0.1)',
            maxWidth: '1028px',
            minHeight: '265px',
        },

        '& .img': {
            backgroundPosition: 'center bottom',
            backgroundImage: `url(${cardImage(errorCode)})`,
            backgroundSize: 'cover',
            width: '100%',
            height: 'auto',
            borderBottomLeftRadius: theme.variables.paper.borderRadius,
            borderTopLeftRadius: theme.variables.paper.borderRadius,

            [theme.breakpoints.down('md')]: {
                backgroundPosition: 'center',
                height: '250px',
                borderTopLeftRadius: theme.variables.paper.borderRadius,
                borderTopRightRadius: theme.variables.paper.borderRadius,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
            },
        },

        '& .card': {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '30px 20px',
            width: '100%',
        },

        '& .content': {
            wordBreak: 'break-word',
        },

        '& p': {
            color: theme.color.text.main,
            fontWeight: 600,
            fontSize: '16px',
            lineHeight: '20px',

            '&.title': {
                fontWeight: 600,
                fontSize: '40px',
                lineHeight: '44px',
                marginBottom: '25px',
            },

            '&.errorId': {
                fontWeight: 400,
                marginTop: '20px',
                color: theme.color.text.secondary,
            },
        },

        '& .supportEmail': {
            textDecoration: 'underline',
        },

        '& .button': {
            backgroundColor: theme.color.button.main,
            borderRadius: theme.variables.button.borderRadius,
            fontSize: '16px',
            lineHeight: '18px',
            maxWidth: '350px',
            width: '100%',
            height: '46px',
            fontWeight: 600,
            color: theme.color.button.text,
            textTransform: 'none',
            boxShadow: 'none',
            marginTop: '30px',

            '&:hover, &:active': {
                backgroundColor: theme.color.button.mainHover,
            },
        },
    },
    skeletonWrap: {
        display: 'flex',
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        height: `calc(100vh - ${theme.variables.navHeight})`,

        '& .skeletonError': {
            width: '100%',
            maxWidth: '1028px',
        },
    },
}))
